import {SvgIconData} from '@shared-web/components/core/svg_icon';

export const plusIcon: SvgIconData = {
  viewBox: '-0.5 -0.5 40 40',
  element: (
    <path d="M35 15H24V4a4 4 0 1 0-9 0v11H4a4 4 0 1 0 0 9h11v11a4 4 0 1 0 9 0V24h11a4 4 0 1 0 0-9" />
  ),
};
